// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1f424","gfeWrapper":"CalendarEvent_gfeWrapper__2VROU"};